import { useCallback, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CircularProgress, Icon } from "@mui/material";
import { Alert, Flex } from "antd";

import "../../shared/css/basicStyles.css";
import {
  getNBKtoken,
  getNBKtokenFromCode,
} from "../../shared/api/edificeRequest";
import { useAuth } from "../../shared/context/TokenContext";

const Dispatcher = () => {
  const { cleanCookies, refresh } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [msgLoading, setMsgLoading] = useState(
    "Récupération des informations depuis l'ENT..."
  );
  const [openInfo, setOpenInfo] = useState(false);

  const loadTokenID = useCallback(
    async (id: string, url: string) => {
      if (isLoading) return;
      setIsLoading(true);
      if (cleanCookies) cleanCookies();

      // console.log("🧠🧠 ~ url:", url);
      if (url.endsWith("/")) url = url.slice(0, -1);

      const tokenNBK = await getNBKtoken(id, url);
      // console.log("🚀 ~ tokenNBK:", tokenNBK);
      if (!tokenNBK || !tokenNBK.accessToken || tokenNBK.error) {
        setError(true);
        setMsgLoading(tokenNBK?.msg || "Impossible de récupérer les données");
        return;
      }

      if (refresh) await refresh(tokenNBK.accessToken);

      if (tokenNBK.created && tokenNBK.type === "teacher")
        navigate("/edifice/welcome?type=teacher");
      else if (tokenNBK.created && tokenNBK.type !== "teacher")
        navigate("/edifice/welcome");
      else {
        if (window && window.parent)
          window.parent.postMessage("webapp_nabook", "*");
        navigate("/v2/home");
      }
    },
    [isLoading, cleanCookies, refresh, navigate]
  );

  const loadToken = useCallback(
    async (code: string, url: string) => {
      if (isLoading) return;
      setIsLoading(true);
      if (cleanCookies) cleanCookies();

      // console.log("🧠🧠 ~ url:", url);
      if (url.endsWith("/")) url = url.slice(0, -1);

      const tokenNBK = await getNBKtokenFromCode(code, url);
      // console.log("🚀 ~ tokenNBK:", tokenNBK);
      if (!tokenNBK || !tokenNBK.accessToken || tokenNBK.error) {
        setError(true);
        setMsgLoading(tokenNBK?.msg || "Impossible de récupérer les données");
        return;
      }

      if (refresh) await refresh(tokenNBK.accessToken);

      if (tokenNBK.created && tokenNBK.type === "teacher")
        navigate("/edifice/welcome?type=teacher");
      else if (tokenNBK.created && tokenNBK.type !== "teacher")
        navigate("/edifice/welcome");
      else {
        if (window && window.parent)
          window.parent.postMessage("webapp_nabook", "*");
        navigate("/v2/home");
      }
    },
    [isLoading, cleanCookies, refresh, navigate]
  );

  useEffect(() => {
    setTimeout(() => {
      setOpenInfo(true);
    }, 2000);
    const code = searchParams.get("code");
    const url = searchParams.get("url") || "";
    if (code) loadToken(code, url);
    else if (!code) {
      const id = searchParams.get("id");
      // console.log("🚀 ~ useEffect ~ id:", id);
      if (id) loadTokenID(id, url);
      else {
        setError(true);
        setMsgLoading("Impossible de récupérer les données");
      }
    }
  }, [searchParams, loadToken, loadTokenID]);

  return (
    <div className="mainContainer">
      <Flex
        style={{
          justifyContent: "center",
          alignItems: "center",
          width: "100vw",
          height: "100vh",
        }}
        vertical
        gap={24}
      >
        {error ? (
          <Icon sx={{ fontSize: 50, color: "white" }}>error</Icon>
        ) : (
          <CircularProgress color="inherit" />
        )}
        <div>{msgLoading}</div>

        {openInfo && (
          <div
            style={{
              marginTop: 50,
            }}
          >
            <Alert
              description={
                "Cette opération peut prendre quelques secondes si c'est la première fois que vous vous connectez."
              }
              type="info"
              showIcon
            />
          </div>
        )}
      </Flex>
    </div>
  );
};

export default Dispatcher;
